import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_LICITACOES_PORT}${process.env.VUE_APP_API_PATH}/licitacoes`;

const formDataType = {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
};

export default {
    ElaborarEditalLicitacao(solicitacaoId, data, observacao) {
        const formData = new FormData();
        data.forEach((file) => {
            formData.append('anexos', file);
        });
        formData.append('idSolicitacao', solicitacaoId);
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/solicitacoes/licitacao/${solicitacaoId}/elaborarEditalLicitacao`, formData, formDataType);
    },
    ElaborarJustificativa(solicitacaoId, data, observacao) {
        const formData = new FormData();
        data.forEach((file) => {
            formData.append('anexos', file);
        });
        formData.append('solicitacaoId', solicitacaoId);
        formData.append('observacao', observacao);
        return axiosJwt.post(`${api}/dispensa/${solicitacaoId}/inserirjustificativa`, formData, formDataType);
    },
};
